<template>
  <li>
    <p class="has-text-grey">{{ docAboutTP.name }}:</p>
    <ul class="textpart-files">
      <li v-for="file in docAboutTP.files" :key="file.key">
        <FileLink :file="file" />
      </li>
    </ul>
  </li>
</template>
<script>
import FileLink from '@/components/documents/FileLink';
export default {
  props: {
    projectSchema: {
      type: String,
      required: true,
    },
    docAboutTP: {
      type: Object,
      required: true,
    },
  },
  components: {
    FileLink,
  },
};
</script>
<style scoped lang="scss">
li img {
  margin: 5px 6px 0px 0;
}
</style>
